import type { ArticleListingStoryblok } from "@/types/blok-types";

import TabsUI from "../atoms/TabsUI/TabsUI";
import fetchArticleListing from "./fetchArticleListing";

const ArticleListing = ({
  blok,
  data,
  preview
}: {
  blok: ArticleListingStoryblok;
  data: Awaited<ReturnType<typeof fetchArticleListing>>;
  preview: boolean;
}) => {
  return (
    <TabsUI
      title={blok.title}
      tabsData={data}
      cardType="article"
      preview={preview}
    />
  );
};

export default ArticleListing;
